/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/fp/placeholder.js
// module id = 1281
// module chunks = 2 3 9 10 11